import React from 'react';

const Loading = () => {
  return (
    <section id='loading_sect'>
      <div className='center_sect'>
        <p className='logo'>a</p>
        <div className='span_wrapper'>
          <span className='box1'></span>
          <span className='box2'></span>
          <span className='box3'></span>
          <span className='box4'></span>
        </div>
      </div>
    </section>
  );
};

export default Loading;
